var initMap = function(){
	$('figure.map-single').each(function(i){
		var scope = $(this),
			$map = scope.attr('id') || 'map-office-'+i,
			lat = scope.attr('data-lat-lng').split(',')[0],
			lng = scope.attr('data-lat-lng').split(',')[1],
			badge = scope.attr('data-badge'),
			zoom = 15;

		scope.attr('id',$map);
		distMap[i] = render_map_distillery(document.getElementById($map), i, lat, lng, zoom, badge);

		drawCustomZoom(distMap[i],scope);
	})
};

var distMap = [];

function drawCustomZoom(map,container){
	var cont = $('<div>',{class:'map-zoom-control'}),
		zIn = $('<button>',{class:'map-zoom-control-in'}),
		zOut = $('<button>',{class:'map-zoom-control-out'});
	zIn.click(function(){
		map.setZoom(map.getZoom()+1);
	}).appendTo(cont);
	zOut.click(function(){
		map.setZoom(map.getZoom()-1);
	}).appendTo(cont);
	container.append(cont);
}

function render_map_distillery($map, i, lat, lng, z, badge) {

	// Global i
	var x = i;

	// This is the minimum zoom level that we'll allow
	var minZoomLevel = 13,
		maxZoomLevel = 18,
		z = parseInt(z);

	var $mapCenter = new google.maps.LatLng(lat,lng);

	var args = {
		center: $mapCenter,
		zoom: z,
		scrollwheel: false,
		mapTypeControl: false,
		draggable: true,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles : mapStyle,
		disableDefaultUI: false,
		zoomControl: false,
		zoomControlOptions: {
		  position: google.maps.ControlPosition.RIGHT_BOTTOM
		},
		streetViewControl: false,
		streetViewControlOptions: {
		  position: google.maps.ControlPosition.LEFT_TOP
		},
		fullscreenControl: false
	};

	// Create map 

	distMap[x] = new google.maps.Map($map, args);

	// // Add a markers reference
	distMap[x].markers = [];

	// Add marker
	var $type = location.type;

	var $badge = {
			url:badge,
			size: new google.maps.Size(120,120),
			scaledSize: new google.maps.Size(60,60),
		    origin: new google.maps.Point(0,0),
		    anchor: new google.maps.Point(30,30)
		};
	
	var marker = new google.maps.Marker({
		icon: $badge,
		position: $mapCenter,
		map: distMap[x]
	});

	// Add to array
	distMap[x].markers.push(marker);

	// LIMIT ZOOM
	google.maps.event.addListener(distMap[x], 'zoom_changed', function() {
			if(distMap[x].getZoom() < minZoomLevel){
				distMap[x].setZoom(minZoomLevel);
			}
			if(distMap[x].getZoom() > maxZoomLevel){
				distMap[x].setZoom(maxZoomLevel);
			}
	 		return;
		});

	return distMap[x];	
}

var mapStyle = [
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 17
            }
        ]
    }
]